import axios from 'axios';

export const getFileFromUrl = (url) => {
    const blobType = 'application/force-download'; // 关键点2
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                responseType: 'arraybuffer', // 1.首先设置responseType对象格式为 blob: // 二进制流
            })
            .then(
                (res) => {
                    let blob = new Blob([res.data], {
                        type: blobType,
                    }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
                    let arr = url.split('/');
                    let fileName = arr[arr.length - 1];
                    let file = new File([blob], fileName);
                    resolve(file);
                },
                (err) => {
                    resolve(err.response);
                },
            )
            .catch((error) => {
                reject(error);
            });
    });
};
